import { render, staticRenderFns } from "./SignUp.vue?vue&type=template&id=1fd53ed4&scoped=true&"
import script from "./SignUp.vue?vue&type=script&lang=js&"
export * from "./SignUp.vue?vue&type=script&lang=js&"
import style0 from "./SignUp.vue?vue&type=style&index=0&id=1fd53ed4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd53ed4",
  null
  
)

export default component.exports